/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{font-family:\"Open Sans\",sans-serif;font-weight:500;margin:-4px 0}[_nghost-%COMP%] > *[_ngcontent-%COMP%]{margin:4px 0}"];
export { styles as styles };
